import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { schemaTemplatesMailSignature } from '../tables';

type Arguments = {
    ids: string;
    position?: number;
};

export const schemaTemplateResolver_GetSignatures = z.array(
    schemaTemplatesMailSignature.pick({
        createdAt: true,
        data: true,
        id: true,
        name: true,
        type: true,
        users: true,
    }),
);

export type SchemaTemplateResolver_GetSignatures = z.infer<typeof schemaTemplateResolver_GetSignatures>;

export type TemplateResolver_GetSignatures = Resolver<Arguments, SchemaTemplateResolver_GetSignatures>;
